import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
const PREDEFINED_TASKS = [{
  key: 'custom',
  label: '✨ Tarea Personalizada'
}, {
  key: 'match.pre.tv_channel',
  label: '📺 Asignar canal de televisión'
}, {
  key: 'match.pre.referees',
  label: '⚖️ Asignar árbitros (campo y VAR)'
}, {
  key: 'match.pre.press_conference',
  label: '🎙️ Rueda de prensa previa'
}, {
  key: 'match.pre.callup',
  label: '📋 Convocatoria oficial'
}, {
  key: 'match.live.starting_eleven',
  label: '👥 Once titular (11 participantes)'
}, {
  key: 'match.post.score_and_goals',
  label: '⚽ Resultado final y eventos de gol'
}, {
  key: 'match.post.final_participants',
  label: '🏃 Participantes finales (con suplentes)'
}, {
  key: 'match.post.attendance',
  label: '🏟️ Cifra de asistencia al estadio'
}, {
  key: 'match.post.press_conference',
  label: '🎥 Rueda de prensa post-partido'
}, {
  key: 'match.post.highlights',
  label: '🎬 Resumen en vídeo (Highlights)'
}];
export default class CreateTaldezainaTaskModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "taskKey", 'custom');
    _defineProperty(this, "matchId", '');
    _defineProperty(this, "taskTitle", '');
    _defineProperty(this, "description", '');
    _defineProperty(this, "actionUrl", '');
    _defineProperty(this, "matches", []);
    _defineProperty(this, "existingTasks", []);
    _defineProperty(this, "onTaskCreated", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    const attrs = vnode && vnode.attrs || this.attrs || {};
    this.matches = Array.isArray(attrs.matches) ? attrs.matches : [];
    this.existingTasks = Array.isArray(attrs.existingTasks) ? attrs.existingTasks : [];
    this.onTaskCreated = attrs.onTaskCreated;
    this.taskKey = 'custom';
    this.matchId = '';
    this.taskTitle = '';
    this.description = '';
    this.actionUrl = '';
    this.loading = false;
  }
  className() {
    return 'CreateTaldezainaTaskModal Modal--medium';
  }
  title() {
    return 'Nueva Tarea de Taldezaina';
  }
  getMatchLabel(match) {
    if (!match) return 'Partido';
    let rivalName = 'Rival';
    try {
      const r = typeof match.rival === 'function' ? match.rival() : match.rival;
      if (r) {
        rivalName = typeof r.name === 'function' ? r.name() : r.name || 'Rival';
      } else if (typeof match.opponent === 'function') {
        rivalName = match.opponent() || 'Rival';
      } else if (match.opponent) {
        rivalName = match.opponent;
      }
    } catch (e) {
      rivalName = 'Rival';
    }
    let isLocal = true;
    try {
      isLocal = typeof match.isLocal === 'function' ? match.isLocal() : !!match.isLocal;
    } catch (e) {
      isLocal = true;
    }
    let dateStr = '';
    try {
      const rawDate = typeof match.matchDate === 'function' ? match.matchDate() : match.matchDate;
      if (rawDate) {
        dateStr = " (".concat(new Date(rawDate).toLocaleDateString(), ")");
      }
    } catch (e) {
      dateStr = '';
    }
    const teamName = app.forum && app.forum.attribute('nagusiMatchRatingsPrimaryTeamName') || 'Athletic Club';
    const versus = isLocal ? "".concat(teamName, " vs ").concat(rivalName) : "".concat(rivalName, " vs ").concat(teamName);
    return "".concat(versus).concat(dateStr);
  }
  getMatchId(match) {
    if (!match) return '';
    try {
      return String(typeof match.id === 'function' ? match.id() : match.id || '');
    } catch (e) {
      return '';
    }
  }
  isPredefinedKeyAlreadyPending(taskKey, matchId) {
    if (taskKey === 'custom' || !matchId) return false;
    if (!Array.isArray(this.existingTasks)) return false;
    return this.existingTasks.some(t => {
      if (!t) return false;
      try {
        const tMatchId = typeof t.matchId === 'function' ? t.matchId() : t.match_id || t.attributes && t.attributes.matchId;
        const tKey = typeof t.taskKey === 'function' ? t.taskKey() : t.task_key || t.attributes && t.attributes.taskKey;
        const tStatus = typeof t.status === 'function' ? t.status() : t.status || t.attributes && t.attributes.status;
        return String(tMatchId) === String(matchId) && tKey === taskKey && tStatus === 'pending';
      } catch (e) {
        return false;
      }
    });
  }
  content() {
    try {
      const isCustom = this.taskKey === 'custom';
      const alreadyPending = !isCustom && this.isPredefinedKeyAlreadyPending(this.taskKey, this.matchId);
      return m("div", {
        className: "Modal-body"
      }, m("div", {
        className: "Form-group",
        style: "margin-bottom: 20px;"
      }, m("label", {
        style: "font-weight: bold; margin-bottom: 8px; display: block;"
      }, "Tipo de Tarea"), m("select", {
        className: "FormControl",
        value: this.taskKey,
        onchange: e => {
          this.taskKey = e.target.value;
          if (this.taskKey !== 'custom' && !this.matchId && this.matches.length > 0) {
            const firstUnplayed = this.matches.find(m => {
              try {
                const scA = typeof m.scoreAthletic === 'function' ? m.scoreAthletic() : m.scoreAthletic;
                const scO = typeof m.scoreOpponent === 'function' ? m.scoreOpponent() : m.scoreOpponent;
                return scA === null && scO === null;
              } catch (err) {
                return false;
              }
            }) || this.matches[0];
            this.matchId = this.getMatchId(firstUnplayed);
          }
          m.redraw();
        },
        style: "border-radius: 8px; height: 42px;"
      }, PREDEFINED_TASKS.map(opt => {
        const disabled = !isCustom && opt.key !== 'custom' && this.isPredefinedKeyAlreadyPending(opt.key, this.matchId);
        return m("option", {
          value: opt.key,
          disabled: disabled
        }, opt.label, " ", disabled ? '(Ya está pendiente para este partido)' : '');
      }))), !isCustom && m("div", {
        className: "Form-group",
        style: "margin-bottom: 20px;"
      }, m("label", {
        style: "font-weight: bold; margin-bottom: 8px; display: block;"
      }, "Partido Asociado *"), m("select", {
        className: "FormControl",
        value: this.matchId,
        onchange: e => {
          this.matchId = e.target.value;
          m.redraw();
        },
        style: "border-radius: 8px; height: 42px;",
        required: true
      }, m("option", {
        value: ""
      }, "-- Selecciona el Partido --"), this.matches.map(match => m("option", {
        value: this.getMatchId(match)
      }, this.getMatchLabel(match)))), alreadyPending && m("p", {
        style: "color: #ff5252; font-size: 0.9em; margin-top: 6px; font-weight: bold;"
      }, "\u26A0\uFE0F Ya existe una tarea pendiente de este tipo para el partido seleccionado.")), isCustom && m("div", null, m("div", {
        className: "Form-group",
        style: "margin-bottom: 16px;"
      }, m("label", {
        style: "font-weight: bold; margin-bottom: 8px; display: block;"
      }, "T\xEDtulo de la Tarea *"), m("input", {
        className: "FormControl",
        type: "text",
        placeholder: "Ej: Subir nuevo escudo de rival, revisar dorsal...",
        value: this.taskTitle,
        oninput: e => this.taskTitle = e.target.value,
        style: "border-radius: 8px; padding: 10px 14px;",
        required: true
      })), m("div", {
        className: "Form-group",
        style: "margin-bottom: 16px;"
      }, m("label", {
        style: "font-weight: bold; margin-bottom: 8px; display: block;"
      }, "Descripci\xF3n (Opcional)"), m("textarea", {
        className: "FormControl",
        rows: 3,
        placeholder: "Explica detalladamente la labor a realizar...",
        value: this.description,
        oninput: e => this.description = e.target.value,
        style: "border-radius: 8px; padding: 10px 14px;"
      })), m("div", {
        className: "Form-group",
        style: "margin-bottom: 16px;"
      }, m("label", {
        style: "font-weight: bold; margin-bottom: 8px; display: block;"
      }, "Partido Asociado (Opcional)"), m("select", {
        className: "FormControl",
        value: this.matchId,
        onchange: e => this.matchId = e.target.value,
        style: "border-radius: 8px; height: 42px;"
      }, m("option", {
        value: ""
      }, "-- Sin partido (Tarea General) --"), this.matches.map(match => m("option", {
        value: this.getMatchId(match)
      }, this.getMatchLabel(match))))), m("div", {
        className: "Form-group",
        style: "margin-bottom: 20px;"
      }, m("label", {
        style: "font-weight: bold; margin-bottom: 8px; display: block;"
      }, "Enlace de Acci\xF3n (URL opcional)"), m("input", {
        className: "FormControl",
        type: "text",
        placeholder: "Ej: /taldezaina/rivales o https://...",
        value: this.actionUrl,
        oninput: e => this.actionUrl = e.target.value,
        style: "border-radius: 8px; padding: 10px 14px;"
      }))), m("div", {
        className: "Form-group",
        style: "display: flex; gap: 12px; justify-content: flex-end; margin-top: 25px;"
      }, m(Button, {
        className: "Button Button--secondary",
        onclick: () => this.hide(),
        disabled: this.loading
      }, "Cancelar"), m(Button, {
        type: "submit",
        className: "Button Button--primary",
        loading: this.loading,
        disabled: this.loading || (isCustom ? !this.taskTitle.trim() : !this.matchId || alreadyPending)
      }, "Crear Tarea")));
    } catch (err) {
      console.error('Error rendering CreateTaldezainaTaskModal:', err);
      return m("div", {
        className: "Modal-body"
      }, m("p", {
        style: "color: #ff5252;"
      }, "Error al renderizar el di\xE1logo: ", String((err == null ? void 0 : err.message) || err)));
    }
  }
  onsubmit(e) {
    if (e) {
      e.preventDefault();
    }
    this.loading = true;
    const isCustom = this.taskKey === 'custom';
    const attributes = {
      task_key: this.taskKey,
      match_id: this.matchId ? parseInt(this.matchId, 10) : null,
      title: isCustom ? this.taskTitle.trim() : null,
      description: isCustom ? this.description.trim() || null : null,
      action_url: isCustom ? this.actionUrl.trim() || null : null
    };
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/taldezaina/tasks',
      body: {
        data: {
          type: 'nagusi_taldezaina_tasks',
          attributes
        }
      }
    }).then(response => {
      app.store.pushPayload(response);
      if (response && response.meta && typeof response.meta.pendingCount !== 'undefined') {
        if (!app.forum.data.attributes) {
          app.forum.data.attributes = {};
        }
        app.forum.data.attributes.pendingTaldezainaTasksCount = response.meta.pendingCount;
      }
      this.loading = false;
      this.hide();
      app.alerts.show({
        type: 'success'
      }, 'Tarea de Taldezaina creada correctamente.');
      if (this.onTaskCreated) {
        this.onTaskCreated();
      }
    }).catch(err => {
      this.loading = false;
      m.redraw();
      const msg = err && err.response && err.response.errors && err.response.errors[0] && err.response.errors[0].detail ? err.response.errors[0].detail : 'Error al crear la tarea.';
      app.alerts.show({
        type: 'error'
      }, msg);
    });
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/taldezaina/CreateTaldezainaTaskModal', CreateTaldezainaTaskModal);